import lazyLoading from "./lazyLoading";

export default {
  name: "events",
  meta: {
    icon: "fa-calendar",
    expanded: false,
    label: "Evénements",
    permissions: "list events"
  },

  children: [
    {
      name: "list-events",
      path: "/admin/events/liste",
      meta: {
        title: "Liste des événements",
        label: "Evénements",
        //isAdminStaff: true,
        permissions: "list events"
      },
      component: lazyLoading("events/EventList")
    },
    {
      name: "new-event",
      path: "/admin/event/new",
      meta: {
        title: "Nouvel événement",
        label: "Ajouter",
        //isAdminStaff: true,
        permissions: "create event"
      },
      component: lazyLoading("events/Event")
    },
    {
      name: "event-category-templates",
      path: "/admin/events/templates",
      meta: {
        title: "Templates d'emails",
        label: "Templates emails",
        //isAdminStaff: true,
        permissions: "list events"
      },
      component: lazyLoading("events/EventCategoryTemplates")
    }
  ]
};
